import qs from "query-string";

import { createApiPdf, createApiV2 } from "./common";

export const getProductsFromSalesOrderForCustomPdf =
  ({ customerUid, orderUid, searchFilter } = {}) =>
  (token) =>
    createApiV2(
      "GET",
      `customers/${customerUid}/orders/${orderUid}/custom_pdf/?${qs.stringify(searchFilter)}`
    )(token);

export const getDrawingsFromSalesOrder =
  ({ customerUid, orderUid } = {}) =>
  (token) =>
    createApiV2("GET", `customers/${customerUid}/orders/${orderUid}/drawings/`)(token);

export const sendToCustomWorkOrderPrint = (data) => (token) =>
  createApiPdf("POST", "order/custom_work_order_print", {
    responseType: "arraybuffer",
    Accept: "/application/pdf",
    headers: { "Content-Type": "multipart/form-data" },
  })(token, data);

export const getOrderAttachments =
  ({ customerUid, orderUid } = {}) =>
  (token) =>
    createApiV2("GET", `customers/${customerUid}/orders/${orderUid}/attachments/`)(token);
